document.addEventListener("DOMContentLoaded", function () {
  const counterRepairs = document.getElementById("counter-repairs");
  const counterSpecialists = document.getElementById("counter-specialists");
  const counterRent = document.getElementById("counter-rent");

  let countersStarted = false;

  function startCounter(target, start, end, duration) {
    let current = start;
    const range = end - start;
    const increment = range / (duration / 16); // 16ms to około jedna klatka (60 klatek na sekundę)

    function updateCounter() {
      current += increment;
      if (current >= end) {
        current = end;
        target.innerText = Math.floor(current);
      } else {
        target.innerText = Math.floor(current);
        requestAnimationFrame(updateCounter);
      }
    }
    requestAnimationFrame(updateCounter);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !countersStarted) {
          countersStarted = true;
          const duration = 4000; // 4 sekundy dla wszystkich liczników

          startCounter(counterRepairs, 0, 90000, duration);
          startCounter(counterSpecialists, 0, 100, duration);
          startCounter(counterRent, 0, 12000, duration);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 1,
    }
  );

  observer.observe(counterRepairs);
});
